var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoAssetSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 119,
    viewBox: "0 0 152 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.4055 73.3477C99.3535 71.869 99.9052 70.1143 99.9052 68.23C99.9052 62.9682 95.6204 58.7024 90.3351 58.7024C85.0495 58.7024 80.7646 62.9682 80.7646 68.23C80.7646 70.1143 81.3164 71.869 82.2643 73.3477",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4785 50.6V57.04",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6881 18.4686H36.9339C35.0256 18.4686 33.4785 20.0088 33.4785 21.9087V36.9043",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.899 30.1045H93.3948C92.4782 30.1045 91.5993 29.7421 90.9514 29.097L85.625 23.7943",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M151 117.994V33.5448C151 31.6452 149.453 30.105 147.545 30.105H119.075",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4785 68.1666V73.582",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105.949 117.995H151L115.755 74.8525C115.099 74.0491 114.115 73.5827 113.075 73.5827H4.46198C1.55162 73.5827 -0.0552172 76.9456 1.7813 79.1934L32.4422 116.726C33.0984 117.529 34.0829 117.995 35.1229 117.995H94.7736",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6309 72.0039V68.9992",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6309 60.5205V8.23877",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "25.08 37.62"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6309 4.00098V0.996262H48.649",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5811 0.995117H127.558",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "26.31 39.47"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M132.025 0.996262H135.043V4.00098",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M135.043 13.2773V85.9395",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "27.44 41.16"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M135.043 90.5754V93.5801",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M86.049 19.828C86.049 23.9805 82.6676 27.3467 78.4968 27.3467C74.3255 27.3467 70.9443 23.9805 70.9443 19.828C70.9443 15.6755 74.3255 12.3093 78.4968 12.3093C82.6676 12.3093 86.049 15.6755 86.049 19.828Z",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4104 43.7235C37.4104 47.876 34.0292 51.2422 29.8582 51.2422C25.6871 51.2422 22.3057 47.876 22.3057 43.7235C22.3057 39.571 25.6871 36.2048 29.8582 36.2048C34.0292 36.2048 37.4104 39.571 37.4104 43.7235Z",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M103.116 42.0136L96.6973 48.4043",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M103.116 48.4043L96.6973 42.0136",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0549 2.32021L23.6357 8.71094",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0549 8.71094L23.6357 2.32021",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M124.759 107.876H94.2703C93.3278 107.876 92.4396 107.438 91.8685 106.691L84.0553 96.4701C83.2989 95.4809 84.0076 94.0579 85.2559 94.0579H115.744C116.687 94.0579 117.575 94.4963 118.146 95.243L125.96 105.464C126.716 106.453 126.007 107.876 124.759 107.876Z",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0005 107.876H62.1514",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9457 100.4H65.0674",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAssetSvg);
export default __webpack_public_path__ + "static/media/noAssetSvg.0d6f3fd30326c34756e887411ef08bfa.svg";
export { ForwardRef as ReactComponent };